// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__AD0s6","container":"styles_container__16L6b","title":"styles_title__de35x","wrapper":"styles_wrapper__1r_1e","answer":"styles_answer__E2geu"};